import ToggleSearchDropdown from './ToggleSearchDropdown';

export { type ToggleSearchDropdownProps } from './ToggleSearchDropdown';
export default ToggleSearchDropdown;
